// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2tMcz","overflowing":"ReadFullNote_overflowing__3dXZu"};